import React from "react";
import { WorkflowIcon, GitBranchIcon, GaugeIcon, FileTextIcon, ListChecksIcon, LightbulbIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { CtaButton } from "./CtaButton";
import { toolkit } from "../data/content";
const icons = [WorkflowIcon, GitBranchIcon, GaugeIcon, FileTextIcon, ListChecksIcon, LightbulbIcon];
export function Toolkit() {
  return <section className="w-full bg-canvas px-5 py-16 sm:py-20" data-id="element-276" data-mp="av6rikzu1eld">
      <SectionHeading eyebrow="Your Complete BCM Diagnostic Toolkit" title="Practical Resources to Apply the Framework to Your Own Cases" data-id="element-277" data-mp="axswccvc9fzw" />
      <ul className="mx-auto mt-10 grid max-w-5xl gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-278" data-mp="kskxtrs1kmzy">
        {toolkit.map((t, i) => {
        const Icon = icons[i];
        return <li key={t.title} className="rounded-2xl bg-white p-6" data-id="element-279" data-mp="2mkh7evunfms3" data-mpi={i}>
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand text-white" data-id="element-280" data-mp="2hm5xkl4ctc9v">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-281" data-mp="200h06gadkqtt" />
              </span>
              <h3 className="mt-4 font-display text-lg font-extrabold uppercase leading-tight text-navy" data-id="element-282" data-mp="1zye1l7v5ppdh">{t.title}</h3>
              <p className="mt-2 text-base leading-relaxed text-muted" data-id="element-283" data-mp="2915df8ry2n5n">{t.body}</p>
            </li>;
      })}
      </ul>
      <p className="mx-auto mt-8 max-w-2xl text-center text-base leading-relaxed text-muted" data-id="element-284" data-mp="2dsnedwtywnqm">
        The complete system is designed to help you organize your diagnostic work—not replace your training, technical
        judgment, or manufacturer-specific service information.
      </p>
      <div className="mt-10" data-id="element-285" data-mp="2rr4ylkknzi3s">
        <CtaButton data-id="element-286" data-mp="2rrwivz8t9ter">I Want the Complete Toolkit</CtaButton>
      </div>
    </section>;
}